import { RouteConfig } from 'vue-router'

const LAYOUT = () => import('@/layout/index.vue')

function meta(title: string, hidden = false) {
  return { hidden, icon: '', link: '', target: null, title }
}

function layout(
  path: string,
  name: string,
  title: string,
  children: RouteConfig[]
): RouteConfig {
  return {
    component: LAYOUT,
    meta: meta(title),
    name,
    path,
    children
  }
}

export const businessRoute: RouteConfig[] = [
   layout('/task', 'store_manager', '任务管理', [
    {
      component: () => import('@/views/business/taskManage/index.vue'),
      meta: meta('任务管理'),
      name: 'taskManage_list',
      path: 'taskManage/index'
    }
  ]),
  layout('/entry', 'entry_manager', '报名管理', [
    {
      component: () => import('@/views/business/entryManage/index.vue'),
      meta: meta('报名管理'),
      name: 'entryManager_list',
      path: 'entryManage/index'
    }
  ]),
  layout('/entry', 'entry_manager', '达人审核', [
    {
      component: () => import('@/views/business/talentAuth/index.vue'),
      meta: meta('达人审核'),
      name: 'talent_auth',
      path: 'talentAuth/index'
    }
  ]),
  layout('/entryManagePt', 'entryManage_Pt', '平台管理', [
    {
      component: () => import('@/views/business/financeManage/storeMange/index.vue'),
      meta: meta('商户管理'),
      name: 'storeMange_list',
      path: 'storeMange/index'
    },
    {
      component: () => import('@/views/business/entryManagePt/index.vue'),
      meta: meta('任务佣金'),
      name: 'entryManage_list',
      path: 'entryManage/index'
    }
  ]),
  layout('/businessFlow', 'business_flow', '流水管理', [
    {
      component: () => import('@/views/business/financeManage/businessFlow/index.vue'),
      meta: meta('商家流水'),
      name: 'businessFlow_list',
      path: 'businessFlow/index'
    },
    {
      component: () => import('@/views/business/financeManage/talentFlow/index.vue'),
      meta: meta('达人流水'),
      name: 'talentFlow_list',
      path: 'talentFlow/index'
    }
  ]),
  layout('/talent', 'talent_pool', '达人管理', [
    {
      component: () => import('@/views/business/talentPool/index.vue'),
      meta: meta('抖音达人'),
      name: 'talentPool_list',
      path: 'talentPool/index'
    },
    {
      component: () => import('@/views/business/xhsTalentPool/index.vue'),
      meta: meta('小红书达人'),
      name: 'xhsTalentPool_list',
      path: 'xhsTalentPool/index'
    },
    {
      component: () => import('@/views/business/dpTalentPool/index.vue'),
      meta: meta('大众点评达人'),
      name: 'dpTalentPool_list',
      path: 'dpTalentPool/index'
    }
  ]),
 
  // layout('/videoManage', 'taskVideo_manager', '素材管理', [
  //   {
  //     component: () => import('@/views/business/taskVideo/index.vue'),
  //     meta: meta('视频素材'),
  //     name: 'taskVideo_list',
  //     path: 'taskVideo/index'
  //   },
  //   {
  //     component: () => import('@/views/business/taskImages/index.vue'),
  //     meta: meta('图片素材管理'),
  //     name: 'taskImages_list',
  //     path: 'taskImages/index'
  //   }
  // ]),
  layout('/toolManager', 'moreTool_manager', '更多工具管理', [
    {
      component: () => import('@/views/business/moreTool/index.vue'),
      meta: meta('更多工具'),
      name: 'moreTool_list',
      path: 'moreTool/index'
    }
  ])
]
